import React from 'react';
import { Box } from '@mui/material';
import ResponsiveImage from '../ResponsiveImage';
import { COLORS } from '../../theme/designTokens';

const BeratungParallaxImages: React.FC = () => (
  <Box
    data-section-bg={COLORS.bg}
    data-section-theme="light"
    sx={{
      position: 'relative',
      width: '100%',
      height: '100vh',
      overflow: 'hidden',
      backgroundColor: COLORS.bg,
    }}
  >
    <ResponsiveImage
      base="fassade"
      widths={[480, 768, 1024]}
      sizes="100vw"
      alt="Fassade Maximiliansplatz, Kanzlei Zöllner Lorenz"
      loading="lazy"
      imgSx={{ objectFit: 'cover', objectPosition: 'center center' }}
    />
    <Box
      sx={{
        position: 'absolute',
        inset: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.18)',
        pointerEvents: 'none',
      }}
    />
  </Box>
);

export default BeratungParallaxImages;
